// Report-param grammar for the emotional-dial block: emd<key> holds the view mode, the line mode
// and the persisted video position as one object. Ported from the coffee block
// (importReportParams / updateReportParams), which read it off the retired EmotionalDial.Lib.

import { LINE_MODE_OPTIONS, VIEW_MODE_OPTIONS } from '@aytm/app/stats/page/question-views/emd/lib/constants'

export const DEFAULT_OPTIONS = { viewMode: 'windmap', lineMode: 'precise', videoTime: 0 }

const isOffered = (options, value) => options.some(option => option.value === value)

// A stored section answers for all three values. A view or line mode the block does not offer --
// missing, or a token no selector lists -- reads as the default, so the selector shows what the
// chart draws and the next change writes a clean section back.
export const resolveReportParams = ({ section } = {}) =>
  undefined === section
    ? { ...DEFAULT_OPTIONS }
    : {
        viewMode: isOffered(VIEW_MODE_OPTIONS, section.viewMode) ? section.viewMode : DEFAULT_OPTIONS.viewMode,
        lineMode: isOffered(LINE_MODE_OPTIONS, section.lineMode) ? section.lineMode : DEFAULT_OPTIONS.lineMode,
        // a section saved without a position stands for the default one, as a missing section does
        videoTime: section.videoTime ?? DEFAULT_OPTIONS.videoTime
      }

export const calcReportParamsSection = ({ viewMode, lineMode, videoTime } = {}) => {
  const section = { viewMode, lineMode, videoTime }

  const isDefault = Object.keys(DEFAULT_OPTIONS).every(key => section[key] === DEFAULT_OPTIONS[key])

  return isDefault ? null : section
}
